import { IExtensionError, ItemExtensionError, IValidationError, ValidationSubject } from './IValidationError';
import { AccountingValidationError, IAccountingValidationError } from './IAccountingValidationError';
import { ClassificationValidationError, IClassificationValidationError } from './IClassificationValidationError';
import { I18nService } from '@lib/i18n';

/**
 * This is returned on some demand endpoints if the demand is invalid.
 */
export interface IDemandValidationError extends IValidationError {
    demandId: string;
    otherErrors: boolean;
    otherErrorsMessage: string;
    extensionErrors: IValidationError[];
}

export class DemandValidationError {
    public readonly demandId: string;
    public readonly otherErrors: boolean;
    public readonly otherErrorsMessage: string;
    public readonly extensionErrors: IExtensionError[];

    public get hasItemErrors(): boolean {
        return this.itemErrors.length > 0;
    }

    public get itemErrors(): IExtensionError[] {
        return this.extensionErrors.filter((error) =>
            [ValidationSubject.ACCOUNTING, ValidationSubject.CLASSIFICATION].includes(error.subject),
        );
    }

    constructor(dto: IDemandValidationError, i18n: I18nService) {
        this.demandId = dto.demandId;
        this.otherErrors = dto.otherErrors;
        this.otherErrorsMessage = dto.otherErrorsMessage;
        this.extensionErrors = this.getExtensionErrors(dto.extensionErrors, i18n);
    }

    public getForItem(itemId: string): string[] {
        return this.itemErrors
            .filter((error) => error instanceof ItemExtensionError && error.itemId === itemId)
            .map((error) => error.message);
    }

    private getExtensionErrors(errors: IValidationError[], i18n: I18nService): IExtensionError[] {
        return errors.map((error) => {
            if (AccountingValidationError.isAccountingValidationError(error.subject)) {
                return new AccountingValidationError(error as IAccountingValidationError, i18n);
            }
            if (ClassificationValidationError.isClassificationValidationError(error.subject)) {
                return new ClassificationValidationError(error as IClassificationValidationError, i18n);
            }
            throw new Error('Unknown extension error type');
        });
    }
}
